export const REDUCER_NAME = 'funnelBuilder'

export const MODE_MONTHLY = 'monthly'

export const MODE_WEEKLY = 'weekly'



// WEBPACK FOOTER //
// ./src/modules/analytics/state/funnel-builder/const.js